export const viewerClassifierOptions = {
  ajaxWithCredentials: true,
  crossOriginPolicy: 'Anonymous',
  homeFillsViewer: true,
  id: 'viewerClassifier',
  immediateRender: true,
  minZoomLevel: 1,
  navigatorAutoFade: false,
  navigatorAutoResize: false,
  navigatorHeight: '150px',
  navigatorWidth: '150px',
  navigatorPosition: `TOP_RIGHT`,
  maxZoomPixelRatio: 9,
  imageLoaderLimit: 2,
  navImages: {
    zoomIn: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    zoomOut: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    home: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    fullpage: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateleft: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateright: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
  },
  panVertical: false,
  preserveImageSizeOnResize: true,
  showNavigator: true,
  showNavigationControl: false,
  visibilityRatio: 1,
  zoomPerClick: 1,
  zoomPerScroll: 2,
  zoomInButton: 'toolbar-zoomIn',
  zoomOutButton: 'toolbar-zoomOut',
  fullPageButton: 'full-page',
  maxImageCacheCount: 100,
}

export const viewerBarcodeOptions = {
  ajaxWithCredentials: true,
  animationTime: 0.5,
  blendTime: 0.1,
  constrainDuringPan: true,
  crossOriginPolicy: 'Anonymous',
  defaultZoomLevel: 2,
  gestureSettingsTouch: {
    flickEnabled: true,
    flickMinSpeed: 500,
    flickMomentum: 1,
    pinchRotate: true,
  },
  homeFillsViewer: true,
  id: 'viewerBarcode',
  imageLoaderLimit: 2,
  maxZoomPixelRatio: Infinity,
  minZoomLevel: 1,
  maxImageCacheCount: 100,
  navigatorAutoFade: false,
  navigatorAutoResize: false,
  navigatorHeight: '150px',
  navigatorWidth: '150px',
  navigatorPosition: `TOP_RIGHT`,
  navImages: {
    zoomIn: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    zoomOut: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    home: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    fullpage: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateleft: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateright: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
  },
  // prefixUrl: '/assets/images/',
  preserveImageSizeOnResize: true,
  showNavigator: true,
  showRotationControl: true,
  timeout: 120000,
  visibilityRatio: 1,
  zoomPerScroll: 1.5,
  zoomPerClick: 1.5,
  zoomInButton: 'toolbar-zoomIn',
  zoomOutButton: 'toolbar-zoomOut',
  fullPageButton: 'toolbar-fullPage',
}

export const viewerSelectionOptions = {
  constrainDuringPan: true,
  crossOriginPolicy: 'Anonymous',
  homeFillsViewer: true,
  id: `viewerSelection`,
  navImages: {
    zoomIn: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    zoomOut: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    home: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    fullpage: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateleft: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateright: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
  },
  showNavigationControl: false,
}

export const viewerLibraryPremerisOptions = {
  ajaxWithCredentials: true,
  crossOriginPolicy: 'Anonymous',
  homeFillsViewer: true,
  id: 'viewerLibraryPremeris',
  immediateRender: true,
  minZoomLevel: 1,
  navigatorAutoFade: false,
  navigatorAutoResize: false,
  navigatorHeight: '150px',
  navigatorWidth: '150px',
  navigatorPosition: `TOP_RIGHT`,
  navImages: {
    zoomIn: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    zoomOut: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    home: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    fullpage: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateleft: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateright: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
  },
  panVertical: false,
  preserveImageSizeOnResize: true,
  showNavigator: true,
  showNavigationControl: false,
  visibilityRatio: 1,
  zoomPerClick: 1,
  zoomPerScroll: 3,
  zoomInButton: 'toolbar-zoomIn',
  zoomOutButton: 'toolbar-zoomOut',
  fullPageButton: 'full-page',
}

export const viewerLibraryWSIoptions = {
  ajaxWithCredentials: true,
  animationTime: 0.5,
  blendTime: 0.1,
  constrainDuringPan: true,
  crossOriginPolicy: 'Anonymous',
  defaultZoomLevel: 2,
  gestureSettingsTouch: {
    flickEnabled: true,
    flickMinSpeed: 500,
    flickMomentum: 1,
    pinchRotate: true,
  },
  homeFillsViewer: true,
  id: 'viewerLibraryWSI',
  maxZoomPixelRatio: Infinity,
  minZoomLevel: 1,
  navigatorAutoFade: false,
  navigatorAutoResize: false,
  navigatorHeight: '150px',
  navigatorWidth: '150px',
  navigatorPosition: `TOP_RIGHT`,
  navImages: {
    zoomIn: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    zoomOut: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    home: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    fullpage: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateleft: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
    rotateright: {
      REST: '',
      GROUP: '',
      HOVER: '',
      DOWN: '',
    },
  },
  preserveImageSizeOnResize: true,
  showNavigator: true,
  showRotationControl: true,
  timeout: 120000,
  visibilityRatio: 1,
  zoomPerScroll: 1.5,
  zoomPerClick: 1.5,
  zoomInButton: 'toolbar-zoomIn',
  zoomOutButton: 'toolbar-zoomOut',
  fullPageButton: 'toolbar-fullPage',
}
